import { FeatureAnalysisRowDTO } from "@models/platform-analysis/entities/steps/feature";
import { Row } from "@tanstack/react-table";
import { VirtualItem } from "@tanstack/react-virtual";
import { memo, useMemo } from "react";
import { TableVirtualizationConfigs } from "../../../configs";
import { AnalysisTableVirtualizedCell } from "../virtualized-cell";

type AnalysisTableVirtualizedColumnsProps = {
  row: Row<FeatureAnalysisRowDTO>;
  columnVirtualizerItems: VirtualItem<Element>[];
};

export const AnalysisTableVirtualizedColumns = memo(
  ({ row, columnVirtualizerItems }: AnalysisTableVirtualizedColumnsProps) => {
    const visibleCells = row.getVisibleCells();

    const virtualizedColumns = useMemo(
      () =>
        columnVirtualizerItems?.slice(
          TableVirtualizationConfigs.NumOfStickyColumn,
        ),
      [columnVirtualizerItems],
    );

    const virtualizedCells = useMemo(
      () =>
        virtualizedColumns?.map((virtualCol) => {
          const cell = visibleCells[virtualCol.index];
          if (!cell) return null;

          return (
            <AnalysisTableVirtualizedCell
              key={`virtual-${row.original.id}-${virtualCol.index}`}
              cell={cell}
            />
          );
        }),
      [virtualizedColumns, visibleCells, row.original.id],
    );

    return <>{virtualizedCells}</>;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.row !== nextProps.row &&
      prevProps.columnVirtualizerItems !== nextProps.columnVirtualizerItems
    );
  },
);
